<template>
    <div class="content" id="startScreen" ref="startScreen">
        <div>
            <div
            class="service-provide-info"
            v-if="startScreenData.startScreenTitle || startScreenData.startScreenSubtitle || startScreenData.startScreenImage"
            :style="startScreenData.startScreenImage"
            >
                <div
                    class="mx-md-auto text-center"
                    v-if="startScreenData.in_question_type_id == vueQueTypeConfig.TYPE_START_SCREEN_TEXT"
                >
                    <h1
                    class="custom-text-color"
                    v-if="startScreenData.startScreenTitle"
                    >{{startScreenData.startScreenTitle}}</h1>
                    <h5
                    class="custom-text-color"
                    v-if="startScreenData.startScreenSubtitle"
                    v-html="formatString"
                    ></h5>
                    <div class="profileImage" v-if="startScreenData.startScreenImage">
                        <img
                            :src="startScreenData.startScreenImage"
                            class="img-responsive w-70 mx-auto profileImagePreview"
                            alt
                        >
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 text-center">
                    <div class="submit" v-if="startScreenData.startScreenButtonText">
                        <button class="btn sub-main" type="button" @click="goToNextContent">
                            {{startScreenData.startScreenButtonText}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
var { queTypeConfig } = require("../../../config/config.js");

export default {
  name: "StartScreen",
  computed: {
    ...mapGetters("previewSurvey", ["surveyStartEndQuestions"]),
    formatString: function() {
      return this.makeHyperlinks(this.surveyStartEndQuestions["start"]["validationDetailsObj"][11]);
    }
  },
  metaInfo() {
    return {
      title: this.siteTitle,
    };
  },
  props: ["siteTitle"],
  //props: ['surveyName', 'surveyDesign'],
  data() {
    return {
      startScreenData: {},
      vueQueTypeConfig: queTypeConfig
    };
  },
  mounted() {
    this.startScreenData = {
      in_question_type_id: this.surveyStartEndQuestions["start"]
        .question_type_details.in_question_type_id,
      startScreenTitle: this.surveyStartEndQuestions["start"][
        "validationDetailsObj"
      ][44]
        ? this.surveyStartEndQuestions["start"]["validationDetailsObj"][44]
        : "",
      startScreenSubtitle: this.surveyStartEndQuestions["start"][
        "validationDetailsObj"
      ][11]
        ? this.surveyStartEndQuestions["start"]["validationDetailsObj"][11]
        : "",
      startScreenButtonText: this.surveyStartEndQuestions["start"][
        "validationDetailsObj"
      ][45]
        ? this.surveyStartEndQuestions["start"]["validationDetailsObj"][45]
        : "",
      startScreenImage: this.surveyStartEndQuestions["start"][
        "validationDetailsObj"
      ][15]
        ? JSON.parse(
            this.surveyStartEndQuestions["start"]["validationDetailsObj"][15]
          )["dataURL"]
        : ""
    };
    console.log("=== StartScreen ===");
    console.log(this.startScreenData);
  },
  created() {},
  methods: {
    goToNextContent() {
      this.$emit("changeContent");
    },
    makeHyperlinks: function(input) {
      const regex = /(?:(?:https?|ftp):\/\/)?(?:www\.)?([a-zA-Z0-9.-]+(?:\.[a-zA-Z]{2,})+)\S+/gi;
      return input.replace(regex, function(match) {
        let href = match;
        if (match.includes('www')) {
          href = "https://" + match;
        } else if (match.startsWith('http')) {
          href = match;
        } else {
          href = "http://" + match;
        }

        return '<a class="st-hyperlink" href="' + href + '" target="_blank">' + match + '</a>';
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Preview/StartScreen.vue